module.exports = "/dist/img/noshi01.b1b8fce6.png";